module.exports = __webpack_public_path__ + "img/lisbon_location_img.14521930.png";